import { useFormContext } from 'react-hook-form';

export const useErrorMessageForField = (fieldKey: string) => {
  const formContext = useFormContext();

  return findFirstErrorMessage(formContext.formState.errors[fieldKey]);
};

function findFirstErrorMessage(errObj: unknown): string {
  if (!errObj || typeof errObj !== 'object') {
    return '';
  }

  if ('message' in errObj && typeof (errObj as any).message === 'string') {
    return (errObj as any).message;
  }

  for (const value of Object.values(errObj)) {
    const result = findFirstErrorMessage(value);
    if (result) {
      return result;
    }
  }

  return '';
}
